import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deactivateUser } from '../services/users';
import { userKeys } from './useUsersQuery';
import { handleUserMutationError } from '../services/userErrorHandler';
import type { AdminUser } from '../types/users.types';

export const useDeactivateUserMutation = () => {
    const queryClient = useQueryClient();

    return useMutation<AdminUser, Error, string>({
        mutationFn: (id) => deactivateUser(id),
        onSuccess: (_, id) => {
            queryClient.invalidateQueries({ queryKey: userKeys.detail(id) });
            queryClient.invalidateQueries({ queryKey: userKeys.lists() });
        },
        onError: (error) => handleUserMutationError(error),
    });
};
